export const storageKeys = {
  newERLSKey: 'aoe.new-educational-resource',
  searchParams: 'aoe.searchParams',
  usedFilters: 'aoe.usedFilters',
  collection: 'aoe.collection',
  collectionSearchParams: 'aoe.collectionSearchParams',
  collectionSearchResults: 'aoe.collectionSearchResults',
  disableForms: 'aoe.disableForms',
  disableLogin: 'aoe.disableLogin',
  userData: 'userData',
  cookiePolicy: 'cookiePolicy',
  language: 'aoe.lang'
}
